import React from "react";

import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

import Logo from "../../../../assets/Logo.png";
import moment from "moment";

const styles = StyleSheet.create({
  mainHeader: {
    display: "flex",
    padding: "0px 20px",
    paddingTop: "10px",
    justifyContent: "space-between",
    flexDirection: "row",
    backgroundColor: "#284F68",
  },
  headerLogo: {
    width: "30%",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
  },
  headerTextSection: {
    width: "70%",
    display: "flex",
    flexDirection: "column",
    padding: "40px 10px 10px 10px",
  },
  headingText: {
    fontSize: "23px",
    marginBottom: "5px",
    color: "#fff",
    display: "block",
  },
  main: {
    display: "flex",
    padding: "0px 20px",
    paddingTop: "10px",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  simpleCard: {
    width: "50%",
    display: "flex",
    flexDirection: "column",
    padding: "10px",
    margin: "10px",
    border: "1px solid #284F68",
    borderRadius: "5px",
  },
  heading: {
    fontSize: "23px",
    marginBottom: "5px",
    color: "#284f68",
  },
  property: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    flexWrap: "wrap",
    margin: "5px 0px",
  },
  tableCard: {
    border: "1px solid #284F68",
    width: "100%",
    padding: "20px",
    paddingTop: "10px",
    borderRadius: "5px",
  },
  table: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  column: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
  },
  tableHeading: {
    marginBottom: "5px",
    fontSize: "14px",
  },
  text: {
    fontSize: "14px",
  },
  row: {
    marginTop: "5px 0px",
    fontSize: "12px",
  },
  value: {
    marginLeft: "5px",
    fontSize: "12px",
  },
});

const PropertyViewPdf = ({ rowData }) => (
  <Document>
    <Page pageNumber={1} wrap>
      <View style={styles.mainHeader}>
        <View style={{ ...styles.headerLogo }}>
          <Image src={Logo}></Image>
        </View>
        <View style={{ ...styles.headerTextSection }}>
          <Text style={styles.headingText}>Excise, Taxation and Narcotics</Text>
          <Text style={styles.headingText}>Control Department</Text>
        </View>
      </View>
      <View style={styles.main}>
        <View style={{ ...styles.simpleCard }}>
          <Text style={styles.text}>PIN:</Text>
          <Text style={styles.value}>{rowData.pin ? rowData.pin : "N/A"}</Text>
        </View>
      </View>
      <View style={styles.main} wrap={false}>
        <View style={{ ...styles.simpleCard }}>
          <Text style={styles.heading}>Basic</Text>
          <View style={styles.property}>
            <Text style={styles.text}>Effect From:</Text>
            <Text style={styles.value}>
              {rowData.with_effect_from ? rowData.with_effect_from : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Effect Date:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.with_effect_date
                ? moment(rowData.with_effect_date).format("DD MMMM YYYY")
                : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>CNIC:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.property_inspector.user.cnic
                ? rowData.property_inspector.user.cnic
                : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>District:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.district ? rowData.district.name : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Tehsil:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.tehsil ? rowData.tehsil.name : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Rating Area:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.rating_area ? rowData.rating_area : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Circle:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.circle.name ? rowData.circle.name : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Cluster Name:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.locality ? rowData.locality : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Cluster Code:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.localityCode ? rowData.locality_code : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Ward:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.ward ? rowData.ward : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text s20pxtyle={styles.text}>Block Name:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.block_name ? rowData.block_name : "N/A"}
            </Text>
          </View>
        </View>
        <View style={styles.simpleCard}>
          <Text style={styles.heading}>Location</Text>
          <View style={styles.property}>
            <Text style={styles.text}>Serial Number:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.serial_number ? rowData.serial_number : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Cluster Name:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.locality ? rowData.locality : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Existing Code:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.existing_code ? rowData.existing_code : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Street Address:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.street_address ? rowData.street_address : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Property Type:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.property_type?.name
                ? rowData.property_type?.name
                : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Latitude:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.latitude ? rowData.latitude : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Longitude:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.longitude ? rowData.longitude : "N/A"}
            </Text>
          </View>
        </View>
      </View>
      <View style={styles.main} wrap={false}>
        <View style={{ ...styles.simpleCard }}>
          <Text style={styles.heading}>Reductions</Text>
          <View style={styles.property}>
            <Text style={styles.text}>Total Reduction:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData?.property_reduction?.total_reduction
                ? rowData.property_reduction.total_reduction
                : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Annual Rental Value:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData?.property_reduction?.annual_rental_value
                ? rowData.property_reduction.annual_rental_value
                : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Annual Value Fixed Objection:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData?.property_reduction?.annual_value_fixed_objection
                ? rowData.property_reduction.annual_value_fixed_objection
                : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Annual Value Fixed Appeal:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.district ? rowData.district.name : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Remarks:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData?.property_reduction?.remarks
                ? rowData.property_reduction.remarks
                : "N/A"}
            </Text>
          </View>
        </View>
        <View style={styles.simpleCard}>
          <Text style={styles.heading}>GARV</Text>
          <View style={styles.property}>
            <Text style={styles.text}>Location:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.location ? rowData.location : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Total Land Area:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.total_land_area ? rowData.total_land_area : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Total Covered Area:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.total_covered_area ? rowData.total_covered_area : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>No Of Stories:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.number_of_stories ? rowData.number_of_stories : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>No Of Rooms:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.number_of_rooms ? rowData.number_of_rooms : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Accommodations:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.accommodation ? rowData.accommodation : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Residential Old:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.residential_old ? rowData.residential_old : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Commercial Old:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.commercial_old ? rowData.commercial_old : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Payable Rent:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.payable_rent ? rowData.payable_rent : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Construction Year:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.construction_year
                ? moment(rowData.construction_year).format("DD MMMM YYYY")
                : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>Reconstruction Year:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.reconstruction_year
                ? moment(rowData.reconstruction_year).format("DD MMMM YYYY")
                : "N/A"}
            </Text>
          </View>
          <View style={styles.property}>
            <Text style={styles.text}>GARV Assessed:</Text>
            <Text style={styles.value}>
              {" "}
              {rowData.garv_assessed ? rowData.garv_assessed : "N/A"}
            </Text>
          </View>
        </View>
      </View>
      <View style={styles.main} wrap={false}>
        <View style={styles.tableCard}>
          <Text style={styles.heading}>Owners</Text>
          <View style={styles.table}>
            <View style={styles.column}>
              <Text style={styles.tableHeading}>Name</Text>
              {rowData.property_owners.length
                ? rowData.property_owners.map((owner) => (
                    <Text style={styles.row} key={owner.name + owner.id}>
                      {owner.name ? owner.name : "N/A"}
                    </Text>
                  ))
                : null}
            </View>
            <View style={styles.column}>
              <Text style={styles.tableHeading}>CNIC</Text>
              {rowData.property_owners.length
                ? rowData.property_owners.map((owner) => (
                    <Text style={styles.row} key={owner.name + owner.id}>
                      {owner.cnic ? owner.cnic : "N/A"}
                    </Text>
                  ))
                : null}
            </View>
            <View style={styles.column}>
              <Text style={styles.tableHeading}>Father Name</Text>
              {rowData.property_owners.length
                ? rowData.property_owners.map((owner) => (
                    <Text style={styles.row} key={owner.name + owner.id}>
                      {owner.father_name ? owner.father_name : "N/A"}
                    </Text>
                  ))
                : null}
            </View>
            <View style={styles.column}>
              <Text style={styles.tableHeading}>Address</Text>
              {rowData.property_owners.length
                ? rowData.property_owners.map((owner) => (
                    <Text style={styles.row} key={owner.name + owner.id}>
                      {owner.address ? owner.address : "N/A"}
                    </Text>
                  ))
                : null}
            </View>
            <View style={styles.column}>
              <Text style={styles.tableHeading}>Ownership Share</Text>
              {rowData.property_owners.length
                ? rowData.property_owners.map((owner) => (
                    <Text style={styles.row} key={owner.name + owner.id}>
                      {owner.ownership_share ? owner.ownership_share : "N/A"}
                    </Text>
                  ))
                : null}
            </View>
          </View>
        </View>
      </View>
      <View style={styles.main} wrap={false}>
        <View style={styles.tableCard}>
          <Text style={styles.heading}>Occupiers</Text>
          <View style={styles.table}>
            <View style={styles.column}>
              <Text style={styles.tableHeading}>Name</Text>
              {rowData.occupiers.length
                ? rowData.occupiers.map((occupier) => (
                    <Text style={styles.row} key={occupier.name + occupier.id}>
                      {occupier.name ? occupier.name : "N/A"}
                    </Text>
                  ))
                : null}
            </View>
            <View style={styles.column}>
              <Text style={styles.tableHeading}>Is Renter</Text>
              {rowData.occupiers.length
                ? rowData.occupiers.map((occupier) => (
                    <Text style={styles.row} key={occupier.name + occupier.id}>
                      {occupier.is_renter ? occupier.is_renter : "N/A"}
                    </Text>
                  ))
                : null}
            </View>
            <View style={styles.column}>
              <Text style={styles.tableHeading}>CNIC</Text>
              {rowData.occupiers.length
                ? rowData.occupiers.map((occupier) => (
                    <Text style={styles.row} key={occupier.name + occupier.id}>
                      {occupier.cnic ? occupier.cnic : "N/A"}
                    </Text>
                  ))
                : null}
            </View>
            <View style={styles.column}>
              <Text style={styles.tableHeading}>Portion</Text>
              {rowData.occupiers.length
                ? rowData.occupiers.map((occupier) => (
                    <Text style={styles.row} key={occupier.name + occupier.id}>
                      {occupier.portion ? occupier.portion : "N/A"}
                    </Text>
                  ))
                : null}
            </View>
            <View style={styles.column}>
              <Text style={styles.tableHeading}>Building Type</Text>
              {rowData.occupiers.length
                ? rowData.occupiers.map((occupier) => (
                    <Text style={styles.row} key={occupier.name + occupier.id}>
                      {occupier.building_type ? occupier.building_type : "N/A"}
                    </Text>
                  ))
                : null}
            </View>
            <View style={styles.column}>
              <Text style={styles.tableHeading}>Covered Area</Text>
              {rowData.occupiers.length
                ? rowData.occupiers.map((occupier) => (
                    <Text style={styles.row} key={occupier.name + occupier.id}>
                      {occupier.covered_area ? occupier.covered_area : "N/A"}
                    </Text>
                  ))
                : null}
            </View>
          </View>
        </View>
      </View>
    </Page>
  </Document>
);

export default PropertyViewPdf;
